exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ies-field__label label[data-v-685ac3e7] {\n    font-size: 0.875rem;\n    line-height: 1.4;\n}\n", ""]);

// exports
